// app/javascript/controllers/theme_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (!this.element.classList.contains('light') && !this.element.classList.contains('dark')) {
      this.assignCurrentMode()
    }
  }

  switch() {
    document.documentElement.classList.contains('dark') ? this.setLightMode() : this.setDarkMode()
  }

  assignCurrentMode() {
    if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  setLightMode() {
    document.documentElement.classList.remove('dark')
    localStorage.theme = 'light'
  }

  setDarkMode() {
    document.documentElement.classList.add('dark')
    localStorage.theme = 'dark'
  }
}
